import { CheckButton } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useExperienceCommercialConsiderationAcknowledged } from '../../../../fields/ExperienceFields';

interface CommercialExperienceCheckButtonProps {
    experienceId: string | undefined;
    readOnly: boolean;
}

export const CommercialExperienceCheckButton: React.FC<CommercialExperienceCheckButtonProps> = ({
    experienceId,
    readOnly = false,
}) => {
    const label = 'I Understand Commercial Experience May Not Be Considered';
    const mobileScreen = isMobileScreen();
    const [commercialConsiderationAcknowledged, set_commercialConsiderationAcknowledged] =
        useExperienceCommercialConsiderationAcknowledged(experienceId);

    return (
        <>
            <div style={{ paddingTop: '.25rem', paddingBottom: '.25rem' }}>
                <CheckButton
                    id='commercialExperienceCheckButton'
                    selected={commercialConsiderationAcknowledged ?? false}
                    onToggle={() => set_commercialConsiderationAcknowledged(!commercialConsiderationAcknowledged)}
                    label={label}
                    width={!mobileScreen ? '500px' : '100%'}
                    disabled={readOnly}
                />
            </div>
        </>
    );
};
